<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <defs>
      <clipPath id="master_svg0_361_6344">
        <rect x="0" y="0" width="16" height="16" rx="0" />
      </clipPath>
    </defs>
    <g
      style="mix-blend-mode: passthrough"
      clip-path="url(#master_svg0_361_6344)"
    >
      <g style="mix-blend-mode: passthrough">
        <path
          d="M3,6.4690093994140625C3,6.4690093994140625,3,14.000509399414062,3,14.000509399414062C3,14.000509399414062,13,14.000509399414062,13,14.000509399414062C13,14.000509399414062,13,6.4690093994140625,13,6.4690093994140625C13,6.4690093994140625,8,2.297009399414063,8,2.297009399414063C8,2.297009399414063,3,6.4690093994140625,3,6.4690093994140625C3,6.4690093994140625,3,6.4690093994140625,3,6.4690093994140625ZM2.1875,5.8440093994140625C2.1875,5.8440093994140625,7.6875,1.2660093994140624,7.6875,1.2660093994140624C7.78117,1.1930094994140625,7.88533,1.1565093994140625,8,1.1565093994140625C8.11467,1.1565093994140625,8.21883,1.1930094994140625,8.3125,1.2660093994140624C8.3125,1.2660093994140624,13.8125,5.8440093994140625,13.8125,5.8440093994140625C13.9375,5.9483393994140625,14,6.078509399414062,14,6.234509399414063C14,6.234509399414063,14,14.500009399414063,14,14.500009399414063C14,14.646009399414062,13.9532,14.765809399414062,13.8595,14.859509399414062C13.7658,14.953209399414062,13.646,15.000009399414063,13.5,15.000009399414063C13.5,15.000009399414063,2.5,15.000009399414063,2.5,15.000009399414063C2.354,15.000009399414063,2.234167,14.953209399414062,2.1405,14.859509399414062C2.0468334,14.765809399414062,1.9999999999999998,14.646009399414062,2,14.500009399414063C2,14.500009399414063,2,6.234509399414063,2,6.234509399414063C2,6.078179399414062,2.0625,5.948009399414063,2.1875,5.8440093994140625C2.1875,5.8440093994140625,2.1875,5.8440093994140625,2.1875,5.8440093994140625Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'SmallHouse',
} as DefineComponent
</script>
